module.exports = __webpack_public_path__ + "static/media/logo_white.08f22eec.svg";